export enum RequisiteStatusEnum {
  APPROVED = "APPROVED",
  CREATED = "CREATED",
  DENIED = "DENIED",
  WAITING_FOR_APPROVE = "WAITING_FOR_APPROVE"
}